var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SingleFieldBarChart',{attrs:{"chart_config":_vm.chart_config,"extent_id":_vm.extent_id,"height":_vm.chart_height,"width":_vm.chart_width,"additional_filters":_vm.additional_filters,"snapshotId":_vm.snapshotId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }